import React from 'react'
import { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Box, Typography, TextField, InputAdornment, IconButton, FormControl, Grid } from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import PropTypes from 'prop-types'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CircleIcon from '@mui/icons-material/Circle'
import FormHelperText from '@mui/material/FormHelperText'
import { AuthContext } from '../../libs/contexts/authContext'

function checkUppercase(str) {
  for (let i = 0; i < str.length; i++) {
    if (str.charAt(i) === str.charAt(i).toUpperCase() && str.charAt(i).match(/[a-z]/i)) {
      return true
    }
  }
  return false
}
function checkLowerCase(str) {
  for (let i = 0; i < str.length; i++) {
    if (str.charAt(i) === str.charAt(i).toLowerCase() && str.charAt(i).match(/[a-z]/i)) {
      return true
    }
  }
  return false
}
const SPECIAL_CHARS = '!@#$%^&*()'

function checkSpecialChars(str) {
  const alreadyFoundChars = []
  for (let i = 0; i < str.length; i++) {
    const currentChar = str[i]
    if (!alreadyFoundChars.includes(currentChar)) {
      if (SPECIAL_CHARS.includes(currentChar)) {
        alreadyFoundChars.push(currentChar)
      }
    }
  }
  return alreadyFoundChars.length >= 1
}

const getIcon = (isChecked) => {
  const smallDotIcon = <CircleIcon sx={{ fontSize: '0.4rem !important' }} />
  const checkCircleIcon = <CheckCircleIcon sx={{ fontSize: '0.8rem !important' }} />
  const iconToBeRendered = isChecked ? checkCircleIcon : smallDotIcon

  return (
    <div
      style={{
        height: '20px',
        width: '15px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {iconToBeRendered}
    </div>
  )
}

export const prepareHelperText = (value, ifMaches, page) => {
  const firstIcon = getIcon(value.length >= 12)
  const secondIcon = getIcon(checkUppercase(value))
  const thirdIcon = getIcon(checkLowerCase(value))
  const fourthIcon = getIcon(checkSpecialChars(value))
  const fifthIcon = getIcon(ifMaches)

  return (
    <div>
      <div style={{ display: 'flex' }}>
        {firstIcon}
        Must contain at least 12 characters
      </div>
      <div style={{ display: 'flex' }}>{secondIcon} Must contain at least 1 uppercase letter</div>
      <div style={{ display: 'flex' }}>{thirdIcon} Must contain at least 1 lowercase letter</div>
      <div style={{ display: 'flex' }}>{fourthIcon} Must contain characters: !@#$%^&*()</div>
      {page === 'register' && <div style={{ display: 'flex' }}>{fifthIcon} Password must match</div>}
    </div>
  )
}

function CreatePasswordPage(props) {
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [disableButton, setdisableButton] = useState(true)
  const { affiliateCode, productId } = useContext(AuthContext)

  const [helperText, setHelperText] = useState('')

  const handleClickShowPassword = () => {
    setShowPassword(true)
  }

  const handleMouseDownPassword = (event) => {
    setShowPassword(false)
  }

  const handlePasswordChange = (e) => {
    setPassword(e.target.value)
  }

  useEffect(() => {
    setHelperText(prepareHelperText(password, false, 'reset'))
    if (checkUppercase(password) && checkSpecialChars(password) && password.length >= 12 && checkLowerCase(password)) {
      setdisableButton(false)
    } else {
      setdisableButton(true)
    }
  }, [password])

  let navigate = useNavigate()
  // const routeChange = (direction) => {
  //   let path = `/?affiliateCode=${props.affiliateCode}`
  //   navigate(path)
  // }

  const handleSubmit = (e) => {
    const query = new URLSearchParams(window.location.search)
    let userEmail = query.get('agent_email')
    let aff = query.get('affiliateCode')

    e.preventDefault()
    const data = {
      email: userEmail,
      password: password,
      portal_type: 'AP',
      productId: productId ? parseInt(productId) : 81401,
    }

    props.updatePassword(data)
    navigate(`/?affiliateCode=${aff}`)

    // routeChange()
  }

  return (
    <div className="background-image-login">
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        flexGrow={1}
        style={{ marginTop: { lg: '40px', md: '40px', sm: '0px' } }}
      >
        <Box sx={homeStyle.main}>
          <Box sx={homeStyle.blueBox}>
            <Box sx={homeStyle.noBeneAvailText}>Create new password</Box>
            <TextField
              variant="outlined"
              type={showPassword ? 'text' : 'password'}
              label="Password"
              value={password}
              onChange={(e) => handlePasswordChange(e)}
              helperText={helperText}
              InputProps={{
                // <-- This is where the toggle button is added.
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .Mui-focused': {
                  color: 'purple',
                },
                '& label.Mui-focused': {
                  color: 'purple !important',
                },
                '& .MuiOutlinedInput-root': {
                  '&.Mui-focused fieldset': {
                    borderColor: 'purple',
                  },
                },
              }}
            />
            <Grid container spacing={2}>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Button
                  type="submit"
                  sx={homeStyle.updateInfoButton}
                  disabled={disableButton}
                  onClick={(e) => handleSubmit(e)}
                >
                  <Typography sx={homeStyle.updateInfoText}>Save Password</Typography>
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Grid>
    </div>
  )
}
export default CreatePasswordPage

CreatePasswordPage.propTypes = {
  messageType: PropTypes.string,
  messageText: PropTypes.string,
  login: PropTypes.func.isRequired,
  removeMessage: PropTypes.func.isRequired,
}

export function PasswordCheck({ password, setPassword, doPasswordsMatch, setDoPasswordsMatch }) {
  const [confirmPassword, setConfirmPassword] = useState('')
  const [helperText, setHelperText] = useState('')
  const [ifMaches, setIfMatches] = useState(false)
  const [showHelperText, setShowHelperText] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [showConPassword, setShowConPassword] = useState(false)

  const handleClickShowConPassword = () => {
    setShowConPassword(true)
  }

  const handleClickShowPassword = () => {
    setShowPassword(true)
  }

  const handleMouseDownPassword = (event) => {
    setShowPassword(false)
  }
  const handleMouseDownConPassword = (event) => {
    setShowConPassword(false)
  }
  const handlePaste = (e) => {
    e.preventDefault()
  }

  useEffect(() => {
    setHelperText(prepareHelperText(password, password === confirmPassword && password.length !== 0, 'register'))
    const matchingValidator = () => {
      if (password === confirmPassword && password.length >= 12) {
        setIfMatches(true)
        setDoPasswordsMatch(true)
      } else {
        setIfMatches(false)
        setDoPasswordsMatch(false)
      }
    }
    matchingValidator()
  }, [password, confirmPassword, setIfMatches, setDoPasswordsMatch])

  return (
    <>
      <Grid item lg={6} md={6} sm={6} xs={12}>
        <FormControl fullWidth>
          <TextField
            variant="outlined"
            type={showPassword ? 'text' : 'password'}
            label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onFocus={(e) => setShowHelperText(true)}
            required
            className="white-box"
            InputProps={{
              // <-- This is where the toggle button is added.
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{
              '& .Mui-focused': {
                color: 'purple',
              },
              '& label.Mui-focused': {
                color: 'purple !important',
              },
              '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                  borderColor: 'purple',
                },
              },
            }}
          />
          {showHelperText ? <FormHelperText>{helperText}</FormHelperText> : <></>}
        </FormControl>
      </Grid>
      <Grid item lg={6} md={6} sm={6} xs={12}>
        <FormControl fullWidth>
          {checkUppercase(password) &&
          checkSpecialChars(password) &&
          checkLowerCase(password) &&
          password.length >= 12 ? (
            <TextField
              variant="outlined"
              type={showConPassword ? 'text' : 'password'}
              label="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              onFocus={(e) => setShowHelperText(true)}
              //   helperText={showHelperText}
              required
              onPaste={handlePaste}
              className="white-box"
              InputProps={{
                // <-- This is where the toggle button is added.
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowConPassword}
                      onMouseDown={handleMouseDownConPassword}
                    >
                      {showConPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          ) : (
            <TextField
              variant="outlined"
              disabled
              type={showConPassword ? 'text' : 'password'}
              label="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              onFocus={(e) => setShowHelperText(true)}
              //   helperText={showHelperText}
              required
              className="white-box"
              InputProps={{
                // <-- This is where the toggle button is added.
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowConPassword}
                      onMouseDown={handleMouseDownConPassword}
                    >
                      {showConPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .Mui-focused': {
                  color: 'purple',
                },
                '& label.Mui-focused': {
                  color: 'purple !important',
                },
                '& .MuiOutlinedInput-root': {
                  '&.Mui-focused fieldset': {
                    borderColor: 'purple',
                    // backgroundColor: "white"
                  },
                },
              }}
            />
          )}

          {showHelperText ? (
            <FormHelperText>{ifMaches ? <>{'Correct password'} </> : <>{'Passwords must match'}</>}</FormHelperText>
          ) : (
            <></>
          )}
        </FormControl>
      </Grid>
    </>
  )
}

const homeStyle = {
  updateInfoText: {
    //color: "#FFFFFF",
    fontFamily: 'Roboto',
    fontStyle: 'bold',
    fontWeight: 800,
    fontSize: '14px',
    lineHeight: '20px',
    textAlign: 'center',
    letterSpacing: '0.1px',
    textTransform: 'none',
  },

  updateInfoButton: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    // alignItems: "center",
    // alignSelf: "center",
    py: '10px',
    // px: "24px",
    width: { lg: '540px', md: '666px', xs: '311px' },
    height: '40px',
    mt: '15px',
    backgroundColor: '#3C4FB9',
    color: 'white',
    borderRadius: '100px',
    flex: 'none',
    order: 2,
    flexGrow: 0,
    '&:hover': {
      backgroundColor: '#9BA5DF',
      color: '#36414E',
    },
    '&:disabled': {
      backgroundColor: '#C4CAF1',
      color: 'white',
      textTransform: 'none',
    },
  },
  noBeneAvailDetailText: {
    width: { lg: '740px', md: '666px', xs: '311px' },
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    textAlign: 'left',
    alignItems: 'center',
    color: '#003C4D',
    flex: 'none',
    alignSelf: 'stretch',
    flexGrow: 0,
  },

  noBeneAvailText: {
    width: { lg: '740px', md: '666px', xs: '311px' },
    height: '32px',
    fontFamily: 'Roboto Slab',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: { lg: '36px', md: '36px', xs: '24px' },
    lineHeight: { lg: '44px', md: '44px', xs: '32px' },
    textAlign: 'center',
    color: '#003C4D',
    flex: 'none',
    flexGrow: 0,
  },

  benefitsAvaillibilityTextFrame: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '0px',
    gap: '12px',
    width: { lg: '740px', md: '666px', xs: '311px' },
    height: { lg: '92px', md: '92px', xs: '140px' },
    flex: 'none',
    order: 2,
    alignSelf: 'center',
    flexGrow: 0,
  },

  blueBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    //alignSelf: "center",
    // justifyContent: "center",
    pt: { lg: '52px', md: '52px', sm: '39px', xs: '24px' },
    pr: { lg: '52px', md: '52px', sm: '39px', xs: '16px' },
    pb: { lg: '52px', md: '52px', sm: '39px', xs: '24px' },
    pl: { lg: '52px', md: '52px', sm: '39px', xs: '16px' },
    gap: { lg: '32px', md: '32px', sm: '32px', xs: '20px' },
    width: { lg: '544px', md: '770px', sm: '500px', xs: '300px' },
    // height: { lg: "825px", md: '750px', sm: "700px", xs: '993px' },
    stretch: { height: '100%' },
    background: '#F5F7FF',
    borderRadius: '8px',
    flex: 'none',
    order: 1,
    alignSelf: 'center',
    flexGrow: 0,
  },

  welcomeText: {
    width: { lg: '626px', md: '770px', xs: '343px' },
    height: { lg: '44px', md: '38px', xs: '32px' },
    fontFamily: 'Roboto Slab',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: { lg: '36px', md: '30px', xs: '24px' },
    lineHeight: { lg: '44px', md: '38px', xs: '32px' },
    textAlign: 'center',
    letterSpacing: '-0.02em',
    color: '#003C4D',
    flex: 'none',
    order: 0,
    alignSelf: 'center',
    flexGrow: 0,
  },
  textField: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: (theme) => theme.palette.gray[100],
    },
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    alignItems: 'center',
    pt: { lg: '120px', md: '90px', sm: '110px', xs: '110px' },
    pr: { lg: '40px', md: '32px', sm: '16px', xs: '16px' },
    pb: { lg: '80px', md: '40px', sm: '32px', xs: '32px' },
    pl: { lg: '40px', md: '85px', sm: '32px', xs: '16px' },
    gap: { lg: '40px', md: '32px', sm: '32px', xs: '20px' },
    width: { lg: '1000', md: '834', xs: '375' },
    height: { lg: '888', md: '1100', xs: '942' },
    background: '#FFFFFF',
    flex: 'none',
    order: 1,
    flexGrow: { lg: 1, md: 0, xs: 0 },
  },
  container: (theme) => ({
    display: 'flex',
  }),
  item: (theme) => ({
    border: '1px solid blue',
  }),
  itemFlexGrow: (theme) => ({
    flexGrow: 1,
    border: '1px solid red',
  }),
}
